
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './mobile/components/error/error.component';
import { LoadingComponent } from './shared/components/loading/loading.component';

const routes: Routes = [
  { path: '',   component: LoadingComponent, pathMatch: 'full' },
  { path: 'h5',  loadChildren: () => import('./mobile/mobile.module').then(m => m.MobileModule)},
  { path: '**', component: ErrorComponent },  // Wildcard route for a 404 page
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
